import apiConfig from "../../apiConfig";

export const getDonationTypesList = async (at) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Types/Get_Donations_Types_List",
		{},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
